<div>
    <form [formGroup]="complexDateForm" id="reporting-set-data-field">
        <div class="input-field">
            <label for="operation-date-dropdown" id="operation-date-label" cvLocalizedText
                langSection="ETL_Reporting_Set" langKey="Operation">OPERATION </label><span class="field-required">
                * </span>
            <cxone-singleselect-dropdown id="operation-date-dropdown" formControlName="operationDropdown"
                [label]="'label'" [isRequired]="true" [primaryKey]="'id'" [options]="operationTypes"
                [showFooter]="false" [search]="false" (selectionChanged)="setToggleDateDifferenceView(true)">
            </cxone-singleselect-dropdown>
        </div>
        <div class="input-field">
            <label for="date-operation-field" id="field-operation-date-label" cvLocalizedText
                langSection="ETL_Reporting_Set" langKey="Left_Operand_Date">
                LEFT OPERAND DATE
            </label> <span class="field-required"> * </span>
            <div class="row add-input-field-container">
                <ng-container
                    *ngIf="_parentData?.hasOwnProperty('leftOperand') &&  _parentData?.leftOperand?.length > 0">
                    <ng-container *ngTemplateOutlet="addedList; context: { $implicit: 'leftOperand' }"></ng-container>
                </ng-container>
                <ng-container
                    *ngIf="!_parentData?.hasOwnProperty('leftOperand') ||  _parentData?.leftOperand?.length === 0">
                    <ng-container *ngTemplateOutlet="emptyList; context: { $implicit: 'leftOperand' }"></ng-container>
                </ng-container>
            </div>
        </div>

        <ng-container *ngIf="!toggleDateDifferenceView">
            <span for="date-section-field" id="date-section-label" cvLocalizedText langSection="ETL_Reporting_Set"
                langKey="Literal_Unit_Values">
                Literal Unit Values
            </span><span class="field-required"> * </span>
            <div class="input-field">
                <label for="seconds-unit-field" id="second-unit-label" cvLocalizedText langSection="ETL_Reporting_Set"
                    langKey="Seconds">
                    SECONDS
                </label>
                <div class="row add-input-field-container">
                    <ng-container *ngIf="_parentData?.hasOwnProperty('seconds') &&  _parentData?.seconds?.length > 0">
                        <ng-container *ngTemplateOutlet="addedList; context: { $implicit: 'seconds' }"></ng-container>
                    </ng-container>
                    <ng-container
                        *ngIf="!_parentData?.hasOwnProperty('seconds') ||  _parentData?.seconds?.length === 0">
                        <ng-container *ngTemplateOutlet="emptyList; context: { $implicit: 'seconds' }"></ng-container>
                    </ng-container>
                </div>
            </div>

            <div class="input-field">
                <label for="minutes-unit-field" id="minutes-unit-label" cvLocalizedText langSection="ETL_Reporting_Set"
                    langKey="Minutes">
                    MINUTES
                </label>
                <div class="row add-input-field-container">
                    <ng-container *ngIf="_parentData?.hasOwnProperty('minutes') &&  _parentData?.minutes?.length > 0">
                        <ng-container *ngTemplateOutlet="addedList; context: { $implicit: 'minutes' }"></ng-container>
                    </ng-container>
                    <ng-container
                        *ngIf="!_parentData?.hasOwnProperty('minutes') ||  _parentData?.minutes?.length === 0">
                        <ng-container *ngTemplateOutlet="emptyList; context: { $implicit: 'minutes' }"></ng-container>
                    </ng-container>
                </div>
            </div>

            <div class="input-field">
                <label for="hours-unit-field" id="hours-unit-label" cvLocalizedText langSection="ETL_Reporting_Set"
                    langKey="Hours">
                    HOURS
                </label>
                <div class="row add-input-field-container">
                    <ng-container *ngIf="_parentData?.hasOwnProperty('hours') &&  _parentData?.hours?.length > 0">
                        <ng-container *ngTemplateOutlet="addedList; context: { $implicit: 'hours' }"></ng-container>
                    </ng-container>
                    <ng-container *ngIf="!_parentData?.hasOwnProperty('hours') ||  _parentData?.hours?.length === 0">
                        <ng-container *ngTemplateOutlet="emptyList; context: { $implicit: 'hours' }"></ng-container>
                    </ng-container>
                </div>
            </div>

            <div class="input-field">
                <label for="days-unit-field" id="days-unit-label" cvLocalizedText langSection="ETL_Reporting_Set"
                    langKey="Days">
                    DAYS
                </label>
                <div class="row add-input-field-container">
                    <ng-container *ngIf="_parentData?.hasOwnProperty('days') &&  _parentData?.days?.length > 0">
                        <ng-container *ngTemplateOutlet="addedList; context: { $implicit: 'days' }"></ng-container>
                    </ng-container>
                    <ng-container *ngIf="!_parentData?.hasOwnProperty('days') ||  _parentData?.days?.length === 0">
                        <ng-container *ngTemplateOutlet="emptyList; context: { $implicit: 'days' }"></ng-container>
                    </ng-container>
                </div>
            </div>

            <div class="input-field">
                <label for="months-unit-field" id="months-unit-label" cvLocalizedText langSection="ETL_Reporting_Set"
                    langKey="Months">
                    MONTHS
                </label>
                <div class="row add-input-field-container">
                    <ng-container *ngIf="_parentData?.hasOwnProperty('months') &&  _parentData?.months?.length > 0">
                        <ng-container *ngTemplateOutlet="addedList; context: { $implicit: 'months' }"></ng-container>
                    </ng-container>
                    <ng-container *ngIf="!_parentData?.hasOwnProperty('months') ||  _parentData?.months?.length === 0">
                        <ng-container *ngTemplateOutlet="emptyList; context: { $implicit: 'months' }"></ng-container>
                    </ng-container>
                </div>
            </div>
        </ng-container>

        <ng-container *ngIf="toggleDateDifferenceView">
            <div class="input-field">
                <label for="date-operation-field" id="field-operation-date-label" cvLocalizedText
                    langSection="ETL_Reporting_Set" langKey="Right_Operand_Date">
                    RIGHT OPERAND DATE
                </label> <span class="field-required"> * </span>
                <div class="row add-input-field-container">
                    <ng-container
                        *ngIf="_parentData?.hasOwnProperty('rightOperand') &&  _parentData?.rightOperand?.length > 0">
                        <ng-container
                            *ngTemplateOutlet="addedList; context: { $implicit: 'rightOperand' }"></ng-container>
                    </ng-container>
                    <ng-container
                        *ngIf="!_parentData?.hasOwnProperty('rightOperand') ||  _parentData?.rightOperand?.length === 0">
                        <ng-container
                            *ngTemplateOutlet="emptyList; context: { $implicit: 'rightOperand' }"></ng-container>
                    </ng-container>
                </div>
            </div>
            <div class="input-field">
                <label for="date-units-dropdown" id="date-units-label" cvLocalizedText langSection="ETL_Reporting_Set"
                    langKey="Units">UNITS </label><span class="field-required">
                    * </span>
                <cxone-singleselect-dropdown id="date-units-dropdown" formControlName="unitsDropdown" [label]="'label'"
                    [isRequired]="true" [primaryKey]="'label'" [options]="unitsOptions" [showFooter]="false"
                    [search]="false" [sortKey]="'id'" (selectionChanged)="unitsValueChange(true)">
                </cxone-singleselect-dropdown>
            </div>
        </ng-container>
    </form>
</div>

<ng-template #addedList let-item>
    <div class="col-10 add-field-box">
        <p class="row ellipsis-text" title="{{_parentData[item][0]?.name}}">{{_parentData[item][0]?.name}}</p>
    </div>
    <div class="col-2 cursor-pointer icon-container">
        <svg class="icon edit-icon" (click)="editInput(_parentData[item][0])">
            <use href="../App_Themes/CXone/icons/edit.svg#edit"></use>
        </svg>
    </div>
</ng-template>
<ng-template #emptyList let-item>
    <div class="col-10 add-field-box">
        <p class="row" cvLocalizedText langSection="ETL_Reporting_Set" langKey="Input_Field_Placeholder">Add input</p>
    </div>
    <div class="col-2 cursor-pointer icon-container">
        <svg class="icon add-icon icon-14" (click)="addNewField(item)">
            <use href="../App_Themes/CXone/icons/add.svg#add"></use>
        </svg>
    </div>
</ng-template>